import { AdminLayout } from '@/features/admin/AdminLayout'
import { adminAuth, adminLoginRedirectSearch } from '@/lib/adminApi'
import {
  Outlet,
  createFileRoute,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/admin')({
  component: AdminWrapper,
})

function AdminWrapper() {
  const location = useLocation()
  const navigate = useNavigate()

  // TanStack Router의 location을 사용하여 리액티브하게 체크
  const isLoginPage = location.pathname === '/admin/login'
  // 외부 앱 OAuth 승인 화면 — 로그인은 필요하지만 사이드바 레이아웃 없이 단독 카드로 보인다
  // (외부 앱에서 넘어온 사용자가 승인 한 가지에만 집중하도록)
  const isStandalonePage = location.pathname === '/admin/oauth-approve'

  // 로그인 체크를 useEffect로 처리하여 적절한 타이밍에 네비게이션
  useEffect(() => {
    // 로그인 페이지가 아니고 로그인되지 않은 경우 — 원래 가려던 딥링크를 redirect 로
    // 넘겨 로그인 후 복귀시킨다 (campus 어드민 returnUrl 규약과 동일)
    if (!isLoginPage && !adminAuth.isLoggedIn()) {
      navigate({
        to: '/admin/login',
        search: adminLoginRedirectSearch(location.pathname + location.searchStr),
        replace: true,
      })
    }
    // /admin 경로에 직접 접근한 경우 고객사 관리로 리다이렉트
    else if (location.pathname === '/admin' && adminAuth.isLoggedIn()) {
      navigate({ to: '/admin/customers', replace: true })
    }
  }, [isLoginPage, navigate, location.pathname, location.searchStr])

  // 로그인 페이지는 레이아웃 없이 렌더링
  if (isLoginPage) {
    return <Outlet />
  }

  // 로그인되지 않은 경우 null 반환 (useEffect에서 네비게이션 처리)
  if (!adminAuth.isLoggedIn()) {
    return null
  }

  // 단독 화면은 레이아웃 없이 — 로그인 확인은 위에서 끝났다
  if (isStandalonePage) {
    return <Outlet />
  }

  // 어드민 레이아웃으로 감싸서 렌더링
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  )
}
